<template>
    <div class="search-panel">
        <transition name="fade-filter" mode="out-in">
            <Filters
                     :data="data"
                     @changeFilter="changeFilter"
            />
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import Filters from './Filters/Filters.vue';
import SkeletonLoader from "./SkeletonLoader/SkeletonLoader.vue";

export default {
    data() {
        return {
            sendData   : new FormData(),
            data       : {},
            priceChange: {
                min: false,
                max: false
            },
            url: this.$dataset.url || '/tests/searchresult.php'
        };
    },

    components: {
        Filters,
        SkeletonLoader
    },

    mounted() {
        this.send('init');
    },

    methods: {
        /**
         * Добавляем data аттрибуты от главного элемента
         * @param {Object} formData - данные, куда присваиваются аттрибуты
         */
        addMainDataset(formData) {
            if (this.$dataset) {
                for (const key in this.$dataset) {
                    if (Object.prototype.hasOwnProperty.call(this.$dataset, key)) {
                        if (!formData.has(key) && key !== 'url') {
                            formData.append(key, this.$dataset[key]);
                        }
                    }
                }
            }
        },

        /**
         * Отправка данных на сервер
         * @param {String} typeRequest - тип запроса
         */
        send(typeRequest = '') {
            this.addMainDataset(this.sendData);

            if (typeRequest === 'init') {
                this.sendData.append('type', 'init');
            } else {
                this.sendData.append('type', 'filter');
            }

            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.post(this.url, this.sendData).then((response) => {
                const status = response.data.success;

                if (status) {
                    this.data = response.data.data;
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
        },

        changeFilter(form) {
            this.sendData = new FormData(form);
            this.send('filter');
        }
    }
};
</script>
